import { render, staticRenderFns } from "./sub-header.vue?vue&type=template&id=1d4dc63a&scoped=true"
import script from "./sub-header.vue?vue&type=script&lang=js"
export * from "./sub-header.vue?vue&type=script&lang=js"
import style0 from "./sub-header.vue?vue&type=style&index=0&id=1d4dc63a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4dc63a",
  null
  
)

export default component.exports